export function partition<T>(
    source: T[],
    predicate: (_: T, idx: number, array: T[]) => boolean,
) {
    return source.reduce<[T[], T[]]>(
        (partitions, _, idx, array) => {
            const [pass, fail] = partitions;
            (predicate(_, idx, array) ? pass : fail).push(_);
            return partitions;
        },
        [[], []],
    );
}
